import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link, useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getData, getFile, putData, postFile } from "../../FetchNodeServices";
import { InfinitySpin } from "react-loader-spinner";
import { useSelector } from "react-redux";
import AlertMessages from "../Mains/Alerts";

const PanelManagement = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullWidthWrapper] = useState("");
  const [profilingList, setProfilingList] = useState([]);
  const [questionsTitleList, setQuestionTitleList] = useState([]);
  const [draggingItem, setDraggingItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [isChecked, setIsChecked] = useState({});
  const [csv, setCsv] = useState(null);
  const [alerts, setAlerts] = useState([]);
  let navigate = useNavigate();
  const [selectedColumns, setSelectedColumns] = useState([]);
  const customer = useSelector((state) => state.user.users[0]);
  const client = useSelector((state) => state.subuser.subusers[0]) || null;
  const user = customer.userId;



  useEffect(() => {
    const allColumns = profilingList.flatMap((profilingItem) => profilingItem.questionAnswer.map((qa) => qa.questionTitle));
    setSelectedColumns([...new Set(allColumns)]);
  }, [profilingList]);

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullWidthWrapper(isActivated ? "fullwrapper" : "");
  };



  const fetchProfilingList = async () => {
    setIsLoading(true);
    let result = await getData(`users/profiling-panel-management-list?userId=${user}&datasource=${client}`);
    setProfilingList(result || []);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchProfilingList();
  }, []);




  useEffect(() => {
    const fetchQuestionTitleList = async () => {
      let result = await getData("users/question-title-list?userId=" + user);
      if (result) {
        const sortedQuestions = result.sort((a, b) => a.orderNo - b.orderNo);
        setQuestionTitleList(sortedQuestions);

      }

      const initialCheckedState = {};
      result.forEach((item) => {
        initialCheckedState[item.orderNo] = item.listingStatus === 1;
      });
      setIsChecked(initialCheckedState);
      setIsLoading(false);
    };
    fetchQuestionTitleList();
  }, []);

  const handleDragStart = (e, item) => {
    setDraggingItem(item);
    e.dataTransfer.setData("text/plain", "");
  };

  const handleDragEnd = () => {
    setDraggingItem(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetItem) => {
    if (!draggingItem) return;

    const sourceIndex = questionsTitleList.findIndex((item) => item === draggingItem);
    const targetIndex = questionsTitleList.findIndex((item) => item === targetItem);

    if (sourceIndex !== -1 && targetIndex !== -1) {
      const updatedList = [...questionsTitleList];
      [updatedList[sourceIndex], updatedList[targetIndex]] = [updatedList[targetIndex], updatedList[sourceIndex]];
      setQuestionTitleList(updatedList);
    }

    setDraggingItem(null);
  };

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0 && acceptedFiles[0].type === "text/csv") {
      const file = acceptedFiles[0];
      validateCSV(file)
        .then(() => {
          setCsv(file);
        })
        .catch((error) => {
          setAlerts([{ variant: "danger", heading: error }]);
        });
    } else {
      alert("Please select a valid CSV file.");
    }
  };

  const validateCSV = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject("No file provided");
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const rows = reader.result.split(/\r?\n/);
        if (rows.length === 0) {
          reject("CSV file is empty");
          return;
        }

        const headers = rows[0].split(",").map((header) => header.trim().toLowerCase());
        console.log("Headers found in file:", headers);

        const requiredHeaders = questionsTitleList.map((item) => item.questionTitle.toLowerCase());
        console.log("Required headers:", requiredHeaders);

        const missingHeaders = requiredHeaders.filter((header) => !headers.includes(header));

        if (missingHeaders.length > 0) {
          const errorMessage = `Missing required headers: ${missingHeaders.join(", ")}`;
          reject(errorMessage);
          setAlerts([{ variant: "danger", heading: errorMessage }]);
        } else {
          resolve();
          console.log("CSV validation successful");
        }
      };
      reader.onerror = () => {
        reject("Error reading CSV file");
      };
      reader.readAsText(file);
    });
  };

  const handleCsvUpload = async () => {
    if (!csv) {
      console.log("No CSV file selected");
      return;
    }
    const formData = new FormData();
    formData.append("file", csv);
    let result = await postFile(`users/add-panel-user-question-answer-csv?userId=${user}`, formData);
    if (result) {
      // console.log("question added from csv");
      setAlerts([{ variant: "success", heading: "Panel Data added from CSV" }]);
      setTimeout(() => {
        fetchProfilingList();
      }, 5000);
      setCsv(null);
    } else {
      // console.log("Failed to add Question");
      setAlerts([{ variant: "danger", heading: "Failed to add panel user" }]);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: "text/csv" });

  const handleCsvChange = () => {
    setCsv(null);
  };

  const handleExportCsv = async () => {
    try {
      const response = await getFile(`users/export-panel-sample-csv?userId=${user}`);
      console.log(response);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Panel_Sample_Data.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error exporting CSV:", error);
      setAlerts([{ variant: "danger", heading: "Error exporting CSV." }]);
    }
  };

  const handleCheckboxChange = (event, item) => {
    setIsChecked((prevIsChecked) => ({
      ...prevIsChecked,
      [item.orderNo]: event.target.checked,
    }));
  };

  const handleChooseColumnSubmit = async () => {
    const formData = questionsTitleList.map((item, index) => ({
      userId: user,
      questionTitle: item.questionTitle,
      orderNo: index + 1,
      listingStatus: isChecked[item.orderNo] ? 1 : 0,
    }));
    console.log(formData);
    try {
      const response = await putData("users/choose-listing-column", formData);
      if (response) {
        // console.log("Data sent successfully!");
        setAlerts([{ variant: "success", heading: "Data sent successfully!" }]);
        fetchProfilingList();
      } else {
        console.error("Error sending data:", response);
        setAlerts([{ variant: "danger", heading: "Error sending data." }]);
      }
    } catch (error) {
      console.error("Error sending data:", error);
      setAlerts([{ variant: "danger", heading: "Error sending data." }]);
    }
  };

  const fillQuestionsList = () => {
    if (!questionsTitleList || questionsTitleList.length === 0) return null;
    return questionsTitleList.map((item, index) => {
      const className = `form-group mb-2 ${item === draggingItem ? "dragging" : ""}`;
      const draggableProps = {
        draggable: true,
        onDragStart: (e) => handleDragStart(e, item),
        onDragEnd: handleDragEnd,
        onDragOver: handleDragOver,
        onDrop: (e) => handleDrop(e, item),
      };
      const checkboxProps = {
        className: "form-check-input fs-18",
        type: "checkbox",
        checked: isChecked[item.orderNo] || false,
        onChange: (e) => handleCheckboxChange(e, item),
      };
      const labelProps = {
        className: "m-0",
        title: item.question,
      };
      return (
        <div className="col-lg-6" key={item.orderNo}>
          <div className={className} {...draggableProps}>
            <div className="form-group d-flex gap-3 align-items-center p-2 border bg-light rounded">
              <span>{index + 1}</span>
              <i className="bi bi-grip-vertical fs-18" style={{ cursor: "move" }} />
              <input {...checkboxProps} />
              <label {...labelProps}>{item.questionTitle}</label>
            </div>
          </div>
        </div>
      );
    });
  };

  const generateTableHeaders = () => {
    if (!profilingList || profilingList.length === 0) return null;

    const sortedColumns = [...selectedColumns].sort((a, b) => {
      const qaA = profilingList[0].questionAnswer.find((qa) => qa.questionTitle === a);
      const qaB = profilingList[0].questionAnswer.find((qa) => qa.questionTitle === b);
      if (!qaA || !qaB) return 0;
      return qaA.orderNo - qaB.orderNo;
    });



    const headers = sortedColumns.map((questionTitle) => (
      <th key={questionTitle}>
        <abbr title={questionTitle}>{questionTitle}</abbr>
      </th>
    ));
    headers.push(<th key="action">Action</th>);
    return <tr>{headers}</tr>;
  };

  const generateTableRows = () => {
    if (!profilingList || !Array.isArray(profilingList) || profilingList.length === 0) {
      return (
        <tr>
          <td colSpan={selectedColumns.length + 1} className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }
    // <<<<<<< ariftayyab
    //         const rows = profilingList
    //       .filter((profilingItem) => {
    //         const hasNonBlankColumn = selectedColumns.some((questionTitle) => {
    //           const qa = profilingItem.questionAnswer.find((qa) => qa.questionTitle === questionTitle);
    //           console.log("Question Title ------> "+ questionTitle)
    //           console.log("QA"+qa)
    //           return qa && Object.values(qa.answers).length>0;
    //         });
    //         return hasNonBlankColumn;
    //       })
    //       .map((profilingItem,rowIndex) => {
    //         const row = selectedColumns.map((questionTitle, colIndex) => {
    //           const qa = profilingItem.questionAnswer.find((qa) => qa.questionTitle === questionTitle);
    //           console.log(" !!"+qa)
    //           console.log("::"+Object.keys(qa.answers)[0])

    //           return <td key={`${rowIndex}-${colIndex}`}>{Object.values(qa.answers).length>0 ? Object.values(qa.answers).join(', '):"No Answer"}</td>;
    //         });


    //         // Add the action column
    //         row.push(
    //           <td key={`${rowIndex}-action`}>
    //             <i className="bi bi-eye mx-1 fs-20" onClick={() => {
    //               navigate("/editpaneluser", { state: { profilingItem } });
    //             }}></i>
    //           </td>
    //         );

    //         return <tr key={rowIndex}>{row}</tr>;
    //       });
    //       console.log("ye rahi rows-----------------"+ rows);
    // =======

    const rows = profilingList
      .filter((profilingItem) => {
        const hasNonBlankColumn = selectedColumns.some((questionTitle) => {
          const qa = profilingItem.questionAnswer.find((qa) => qa.questionTitle === questionTitle);
          return qa && Array.isArray(qa.answer) && qa.answer.length > 0;
        });
        return hasNonBlankColumn;
      })
      .map((profilingItem, rowIndex) => {
        const row = selectedColumns.map((questionTitle, colIndex) => {
          const qa = profilingItem.questionAnswer.find((qa) => qa.questionTitle === questionTitle);
          return <td key={`${rowIndex}-${colIndex}`}>{qa ? qa.answer.join(", ") : ""}</td>;
        });

        // const rows = profilingList.map((profilingItem, rowIndex) => {
        //   const row = selectedColumns.map((questionTitle, colIndex) => {
        //     const qa = profilingItem.questionAnswer.find((qa) => qa.questionTitle === questionTitle);
        //     return <td key={`${rowIndex}-${colIndex}`}>{qa ? qa.answers[0] : ""}</td>;
        //   });

        // Add the action column
        row.push(
          <td key={`${rowIndex}-action`}>
            <i className="bi bi-eye mx-1 fs-20" onClick={() => {
              navigate("/editpaneluser", { state: { profilingItem } });
            }}></i>
          </td>
        );

        return <tr key={rowIndex}>{row}</tr>;
      });


    return rows;
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people"></i> Profiling
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-app-indicator mx-2"></i> Panel Management
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="filter_header fs-12 lh-14">
              <div className="row justify-content-between">
                <div className="col-lg-3">
                  <div className="Add_database">
                    <a
                      className="btn btn-success fs-14 dropdown-toggle border-0"
                      href="#"
                      role="button"
                      id="adddatabase"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Add Database
                    </a>
                    <ul className="dropdown-menu fs-14" aria-labelledby="adddatabase">
                      <li>
                        <Link className="dropdown-item" to="/addpaneluser">
                          Add panel user
                        </Link>
                      </li>
                      <li>
                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#exampleModalCenter" href="#">
                          Upload
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          API
                        </a>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/connect-client-database">
                          Connect client database
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  className="modal fade "
                  id="exampleModalCenter"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalCenterTitle"
                  aria-hidden="true"
                  onBlur={() => handleCsvUpload()}
                >
                  <div className="modal-dialog  modal-dialog-centered" role="document">
                    <div className="modal-content">
                      <div className="column">
                        <div className="col-lg-12">
                          <div className="card px-3 border-light-subtle">
                            <div className="common_form p-2 text-center">
                              <label for="">Import CSV</label>
                              <div className="d-grid gap-2 d-md-block d-md-flex justify-content-md-center mb-3">
                                <button className="btn csv-btn fw-bolder col-12 text-success" type="button">
                                  <a onClick={() => handleExportCsv()} target="_blank" rel="noreferrer">
                                    Download template
                                  </a>
                                </button>
                              </div>
                              <div className="drop-zone ">
                                {csv ? (
                                  <div className="image-preview-container">
                                    <img src={process.env.PUBLIC_URL + "/Images/csv.png"} alt="Uploaded" className="image-preview" />
                                    <div onClick={handleCsvChange} className="text-overlay bg-transparent">
                                      <i className="bi bi-x fs-42 position-absolute top-0 end-0"></i>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="dropzone">
                                    <input {...getInputProps()} />
                                    <div {...getRootProps()} className="drop-zone__prompt fs-16 fw-500 text-dark">
                                      <div className="text-center mb-3">
                                        <i className="bi bi-images fs-50 text-green"></i>
                                      </div>
                                      Drop your files here or <span className="text-green">browse</span>
                                      <br />
                                      <span className="text-grey fs-13"> Maximum size: 50MB</span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 ">
                  <div className="d-flex justify-content-end mt-3 mt-lg-0">
                    <button type="button" className="form-control text-success text-truncate" data-bs-toggle="modal" data-bs-target="#selectColumn">
                      Choose Columns
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="selectColumn"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header d-flex justify-content-between">
                    <h1 className="modal-title text-dark fw-600 fs-5" id="staticBackdropLabel">
                      Choose Columns
                    </h1>
                    <div className="d-flex gap-2">
                      <div className="search_box">
                        <input type="text" value={searchTerm} className="w-100 form-control" onChange={(event) => setSearchTerm(event.target.value)} />
                      </div>
                      <div className="search_button">
                        <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600">
                          <i className="bi bi-search me-1"></i> Search Questions
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="modal-body">
                    <div className="common_form p-3">
                      <div className="row">{fillQuestionsList()}</div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn bg-danger-subtle text-danger" data-bs-dismiss="modal">
                      Cancel
                    </button>
                    <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={() => handleChooseColumnSubmit()}>
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive mt-3">
              <table className="table fs-14 lh-20">
                <thead className="table-light fs-12 lh-16 border-top">{generateTableHeaders()}</thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={profilingList.length} className="text-center">
                        <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
                      </td>
                    </tr>
                  ) : (
                    generateTableRows()
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanelManagement;
